var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderStepper1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_8367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.60938,
    y: 2.21875,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8021 15.8848C24.7078 15.8848 23.6242 16.1003 22.6131 16.5191C21.6021 16.9379 20.6834 17.5517 19.9096 18.3255C18.3468 19.8883 17.4688 22.008 17.4688 24.2181C17.4615 26.1424 18.1278 28.0085 19.3521 29.4931L17.6855 31.1598C17.5698 31.277 17.4915 31.4258 17.4604 31.5874C17.4292 31.7491 17.4467 31.9163 17.5105 32.0681C17.5797 32.218 17.6919 32.344 17.8328 32.4301C17.9738 32.5161 18.1371 32.5584 18.3021 32.5514H25.8021C28.0123 32.5514 30.1319 31.6735 31.6947 30.1107C33.2575 28.5479 34.1355 26.4282 34.1355 24.2181C34.1355 22.008 33.2575 19.8883 31.6947 18.3255C30.1319 16.7627 28.0123 15.8848 25.8021 15.8848ZM25.8021 30.8848H20.3105L21.0855 30.1098C21.2407 29.9536 21.3278 29.7424 21.3278 29.5223C21.3278 29.3021 21.2407 29.0909 21.0855 28.9348C19.9943 27.8448 19.3148 26.4102 19.1627 24.8754C19.0106 23.3406 19.3954 21.8006 20.2515 20.5177C21.1076 19.2348 22.382 18.2884 23.8576 17.8397C25.3332 17.3911 26.9187 17.4679 28.344 18.0572C29.7693 18.6465 30.9462 19.7117 31.6742 21.0713C32.4022 22.431 32.6362 24.0011 32.3364 25.5139C32.0366 27.0268 31.2216 28.389 30.0301 29.3683C28.8386 30.3476 27.3444 30.8836 25.8021 30.8848Z",
    fill: "#9C4900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_8367",
    x: 0.609375,
    y: 0.21875,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.575 0 0 0 0 0.563021 0 0 0 0 0.563021 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_8367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_8367",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderStepper1);
export default __webpack_public_path__ + "static/media/HeaderStepper1.15d742dcbfcb10ebc21d4e3b3d63d97a.svg";
export { ForwardRef as ReactComponent };